import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        type: "document",
        fulltext: "",
    },
    results: []
};

const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setFulltext: (state, { payload }) => {
            state.filters.fulltext = payload;
        },
        setResults: (state, { payload }) => {
            state.results = payload;
        },
        addResults: (state, { payload }) => {
            state.results.push(...payload);
        },
        clearFilters: (state) => {
            state.filters.fulltext = "";
        },
        clearResults: (state) => {
            state.results = [];
        }
    }
});

export const {
    setFulltext,
    setResults,
    addResults,
    clearFilters,
    clearResults
} = documentsSlice.actions;

export default documentsSlice.reducer;
